<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const statGroupVariants = cva('group/stat-group', {
  variants: {
    variant: {
      joined:
        'flex flex-col divide-y divide-neutral-600 rounded-lg border border-neutral-600 bg-white *:grow *:px-5 *:py-4 md:flex-row md:divide-y-0 md:*:px-2 md:*:first:ps-4 md:*:last:pe-4',
      cards: 'grid grid-cols-1 gap-5',
    },
    columns: {
      2: '',
      3: '',
      4: '',
    },
  },
  compoundVariants: [
    { variant: 'cards', columns: 2, class: 'md:grid-cols-2' },
    { variant: 'cards', columns: 3, class: 'md:grid-cols-2 lg:grid-cols-3' },
    { variant: 'cards', columns: 4, class: 'md:grid-cols-2 lg:grid-cols-4' },
  ],
  defaultVariants: {
    variant: 'joined',
    columns: 3,
  },
})

export type StatGroupVariants = VariantProps<typeof statGroupVariants>
</script>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  variant?: StatGroupVariants['variant']
  columns?: StatGroupVariants['columns']
}>()
</script>

<template>
  <div
    data-slot="stat-group"
    :data-variant="variant ?? 'joined'"
    :class="cn(statGroupVariants({ variant, columns }), props.class)"
  >
    <slot />
  </div>
</template>
